import styled from 'styled-components';

interface IContainerProps {
  marginBottom?: string;
}

export const Container = styled.div<IContainerProps>`
  display: flex;
  flex-direction: column;
  margin-bottom: ${props => props.marginBottom || '0px'};
`;

export const DiagnosticTitle = styled.div`
  padding-bottom: 5px;
`;